import { render, staticRenderFns } from "./LogisticsFeedback.vue?vue&type=template&id=09bced54&scoped=true&"
import script from "./LogisticsFeedback.vue?vue&type=script&lang=js&"
export * from "./LogisticsFeedback.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsFeedback.vue?vue&type=style&index=0&id=09bced54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bced54",
  null
  
)

export default component.exports